import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import type { SpaceGroupWithSpaces } from "../../../Sidebar";
import { SpaceGroup } from "./SpaceGroup";
import { SpaceGroupListView } from "./SpaceGroupListView";

export interface SpaceGroupListProps {
  spaceGroupWithSpaces: SpaceGroupWithSpaces[];
}

export const SpaceGroupList = ({
  spaceGroupWithSpaces,
}: SpaceGroupListProps) => (
  <SortableContext
    items={spaceGroupWithSpaces.map(
      spaceGroup => `space-group-${spaceGroup.id}`,
    )}
    strategy={verticalListSortingStrategy}
  >
    <SpaceGroupListView>
      {spaceGroupWithSpaces.map((spaceGroup, index) => (
        <SpaceGroup
          position={index}
          key={spaceGroup.id}
          spaceGroup={spaceGroup}
        />
      ))}
    </SpaceGroupListView>
  </SortableContext>
);
